export const GET_ACTIVATION = "GET_ACTIVATION";
export const FETCH_ACTIVATIONS = "FETCH_ACTIVATIONS";
export const SET_ACTIVATIONS = "SET_ACTIVATIONS";
